export default {
    prefixAgo: null,
    prefixFromNow: "over",
    suffixAgo: "geleden",
    suffixFromNow: null,
    seconds: "minder dan een minuut",
    minute: "ongeveer een minuut",
    minutes: "%d minuten",
    hour: "ongeveer een uur",
    hours: "ongeveer %d uur",
    day: "een dag",
    days: "%d dagen",
    month: "ongeveer een maand",
    months: "%d maanden",
    year: "ongeveer een jaar",
    years: "%d jaar",
    wordSeparator: " ",
    numbers: []
};
